import React, { Component } from 'react';
import { Row, Col, Image, Dropdown, DropdownButton, Form, Button, Pagination, Modal } from 'react-bootstrap';
import { Spinner } from 'react-activity';

import NavbarComponent from '../../Navbar/index';
import RenovateTokenAlert from '../../../RenovateToken';
import Backend from '../../../Backend';
import Connection from '../../../Calls';

import SearchImage from '../../../Images/search.svg';
import BackArrow from '../../../Images/arrow-left.svg';

var date = new Date();
// var HeightScreen = window.screen.height;

function formatMoney(n,c,d,t){
var n = n,
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-$" : "$",
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
    j = (j = i.length) > 3 ? j % 3 : 0;
   return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
 };

class DevicesIndex extends Component {
  constructor(props) {
    super(props)
    this.state = {
      page:1,
      page_size:30,
      pages_amount:1,
      amount_orders:0,
      search:'',
      ecommerce:'',
      list_terminals:[],
      showAddNew:false
    }
  }

  componentWillMount() {
    this.getDevices()
  }

  async getDevices(){
    let { page_size } = this.state
    let orders_promise = new Promise((resolve)=> this.ordersAPI(resolve))
    let orders_data = await orders_promise
    if(orders_data.status.code == '0'){
      let { list_terminals } = orders_data.payload
      // let pages_amount = Math.ceil(amount_orders / page_size);
      this.setState({list_terminals, pages_amount:1})
    }
  }

  ordersAPI(resolve){
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.get_ecomm_devices(response.payload.r01, resolve)
    })
  }

  deleteDevice(deviceID){
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.delete_ecomm_device(response.payload.r01, deviceID, response => {
        this.getDevices();
      })
    })
  }

  changeDeviceStatus(deviceID, currentStatus){
    let newStatus = (currentStatus == 'enabled')?'disabled':'enabled'
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.change_device_status(response.payload.r01, deviceID,newStatus, response => {
        this.getDevices();
      })
    })
  }


  changePage(page) {
    this.setState({page}, ()=>this.getOrders());
  }

  renderList(){
    let { ecomm } = this.props.traductions
    return this.state.list_terminals.map((item)=>{
      return(
        <tr>
          <td>{item.name}</td>
          <td>{item.user_name}</td>
          <td>{item.currency}</td>
          <td className={item.status}>
            {
              item.status != 'pending'
              ?
              <div className="container_50_width">
                <div className='ToggleSwitch ToggleSwitch__rounded'>
                  <div className='ToggleSwitch__wrapper'>
                    <div className={`Slider ${(item.status == 'enabled')&& 'isChecked'}`} onClick={() => { this.changeDeviceStatus(item.id,item.status) }}></div>
                  </div>
                </div>
              </div>
              : 'Pending'
            }

          </td>
          <td className='see-more' onClick={()=>this.deleteDevice(item.id)}>{ecomm.delete}</td>
        </tr>
      )
    })
  }
  renderContent(){
    let { ecomm } = this.props.traductions
    return(
      <div className="ecommerce" style={{ marginTop:0, paddingLeft: 10, paddingRight: 10 }}>

        <div>
          <div className='back-button' style={{width:110, cursor:'pointer', marginTop:-15, marginBottom:10}} onClick={()=>this.props.data.history.push('/ecommerce')}>
            <Image src={BackArrow} style={{ marginTop:-3, marginRight:10}}/>
            {ecomm.goBack}
          </div>
        </div>
        <div className='space-between wrap bmargin10'>
          <span className='ecommerce-subtitle'>{ecomm.b_devices}</span>

          <Button onClick={()=>this.setState({showAddNew:true})} className='ecommerce-button index bmargin10' style={{marginRight:30}}>{ecomm.b_addDevice}</Button>
        </div>
        <div className='container-transactions'>
          <div>
            <Row>

              <Col md={{span:5,offset:6}} className='virtual_exchange_dropdown'>
                <Form.Control style={{ height: 40 }} className="input-signup" type="text" placeholder={ecomm.search} value={this.state.search} onKeyPress={this.handleKeyPress} onChange={(search) => { this.setState({ search: search.target.value }) }} />
              </Col>

              <Col md={1}>
                <div style={{ textAlign:'center'}}>
                  <Button className="signup-button" style={{ height: 40, width:40, padding: 0 }} onClick={() => { this.getOrders(1, 25, "date_new"); }}>
                    <Image src={SearchImage} style={{ width: 20, marginTop:-4 }} />
                  </Button>
                </div>
              </Col>
            </Row>

            <div style={{ height: "calc(100vh - 530px)" }} className="scroll-table-wallets-generals">
              <table className="ecommerce-table medium-dms">
                <thead>
                  <tr>
                    <th>{ecomm.deviceName}</th>
                    <th>{ecomm.deviceUser}</th>
                    <th>{ecomm.deviceCoin}</th>
                    <th>{ecomm.deviceStatus}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {this.renderList()}
                </tbody>
              </table>
            </div>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 20 }}>
              <DropdownButton id="dropdown-item-button-step1" title={this.state.numeroFilas}>
                <Dropdown.Item onClick={() => { this.setState({ numeroFilas: 25 }) }} as="button">25</Dropdown.Item>
                <Dropdown.Item onClick={() => { this.setState({ numeroFilas: 50 }); }} as="button">50</Dropdown.Item>
                <Dropdown.Item onClick={() => { this.setState({ numeroFilas: 100 }); }} as="button">100</Dropdown.Item>
              </DropdownButton>
              <Pagination>
                <Pagination.First disabled={this.state.page === 1 || this.state.spinner} onClick={() => {
                  if (this.state.page !== 0) {
                    this.changePage(1);
                  }
                }} />
                <Pagination.Prev disabled={this.state.page === 1 || this.state.spinner} onClick={() => {
                  if (this.state.page !== 0) {
                    this.changePage(this.state.page - 1);
                  }
                }} />
                {this.state.page > 2 &&
                  <Pagination.Item disabled={this.state.spinner} onClick={() => { this.changePage(this.state.page - 2) }}>{this.state.page - 2}</Pagination.Item>
                }
                {this.state.page > 1 &&
                  <Pagination.Item disabled={this.state.spinner} onClick={() => { this.changePage(this.state.page - 1) }}>{this.state.page - 1}</Pagination.Item>
                }
                <Pagination.Item active>{this.state.page}</Pagination.Item>
                {this.state.page < this.state.pages_amount &&
                  <Pagination.Item disabled={this.state.spinner} onClick={() => { this.changePage(this.state.page + 1) }}>{this.state.page + 1}</Pagination.Item>
                }
                {this.state.page < this.state.pages_amount - 1 &&
                  <Pagination.Item disabled={this.state.spinner} onClick={() => { this.changePage(this.state.page + 2) }}>{this.state.page + 2}</Pagination.Item>
                }
                <Pagination.Next disabled={this.state.page >= this.state.pages_amount || this.state.spinner} onClick={() => {
                  if (this.state.page < this.state.pages_amount) {
                    this.changePage(this.state.page + 1)
                  }
                }} />
                <Pagination.Last disabled={this.state.page >= this.state.pages_amount || this.state.spinner} onClick={() => {
                  if (this.state.page < this.state.pages_amount) {
                    this.changePage(this.state.pages_amount)
                  }
                }} />
              </Pagination>
            </div>
          </div>

        </div>

        <Modal className="ecomm-devices-modal-comntainer" show={this.state.showAddNew} onHide={()=>this.setState({showAddNew:false})}>
          <Modal.Body>
            <div>
              <p className='medium-dms blue-text'>{ecomm.deviceModalTitle}</p>
              <p className='medium-dms gray-text'>{ecomm.deviceModal1}</p>
              <p className='medium-dms gray-text'>{ecomm.deviceModal2}</p>
              {/*missing Translate*/}
              <div style={{textAlign:'center'}}>
                <Button style={{margin:'auto'}} onClick={()=>this.props.data.history.push('/ecommerce/devices/add') }>
                  {ecomm.b_addDevice}
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    )
  }


  render() {
    let { ecomm } = this.props.traductions
    return (
      <div>
        <NavbarComponent data={this.props} selected="ecommerce" logged={true} />
        <RenovateTokenAlert data={this.props} />
        <div className="contenedor-wallets-generals" style={{ paddingLeft: 10, paddingRight: 10 }}>
          {this.renderContent()}
        </div>

      </div >
    );
  }
} export default DevicesIndex;
